

$('#province').on('change', function () { 
    // var conceptName = $(this).find('option:selected').text();
    var SelectedValue = $(this).find('option:selected').val();
    if (SelectedValue != '' && SelectedValue !="other") {
      $("#other-city-container").hide();
      $('#dealerContainer').show();
    } else if(SelectedValue == "other"){
      $('#dealerContainer').hide();
      $("#other-city-container").show();
    } else {
      $("#other-city-container").hide();
      $('#dealerContainer').hide();
    }

    $('#dealer option').hide();
    $('#dealer option').each(function () {
      if ($(this).data('term') == SelectedValue) {
        $(this).show();
        // $(this).prop('selected', true);
      } 
    });

});

// $('#model').on('change',function(){
//   if ($(this).val() != '' ) {
//       $('#vehicle_brochure').show();
//   } else {
//       $('#vehicle_brochure').hide();
//   }
// });


// WEBPACK FOOTER //
// ./scripts/routes/templateOnlineBooking.js